import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T } from 'shared/helper/translate';
import EditingImage from '../images/file-pen-duotone.svg';
import RubriqEditingStatus from './RubriqEditingStatus';
var RubriqNoEditsMessage = function RubriqNoEditsMessage(_ref) {
  var loadingCheckDocumentModal = _ref.loadingCheckDocumentModal,
    onCheckDocument = _ref.onCheckDocument;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center gap-4 pt-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center",
    style: {
      maxWidth: '400px'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: EditingImage,
    alt: ""
  }), /*#__PURE__*/React.createElement("span", {
    className: "fw-semibold fs-4 mt-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: "start improving your writing"
  })), /*#__PURE__*/React.createElement("span", {
    className: "mt-2 text-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.no-edited-documents"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "not-global btn btn-primary mt-4 rounded-3",
    onClick: function onClick() {
      return onCheckDocument();
    },
    disabled: loadingCheckDocumentModal
  }, /*#__PURE__*/React.createElement(T, {
    source: "check document"
  }), loadingCheckDocumentModal && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-1",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }))), /*#__PURE__*/React.createElement(RubriqEditingStatus, {
    isNoEditsMessage: true
  }));
};
export default RubriqNoEditsMessage;